import MockAdapter from 'axios-mock-adapter';
import service from '@/utils/request';
import axios from 'axios';
import { API_PATHS } from '@/config/api';

console.log('初始化模拟服务...');

// axios-mock-adapter配置
console.log('当前axios baseURL:', axios.defaults.baseURL);
console.log('当前service baseURL:', service.defaults.baseURL);

// 创建一个Mock适配器实例，不拦截全局axios，让请求实际发出
const globalMock = new MockAdapter(axios, {
  onNoMatch: 'passthrough', // 允许未匹配的请求通过
  delayResponse: 1000
});

// 检查配置
console.log('globalMock配置:', {
  onNoMatch: globalMock.onNoMatchGetResponse ? 'passthrough' : 'throwException',
  delayResponse: 1000
});

// 创建一个Mock适配器实例，拦截自定义service实例
const serviceMock = new MockAdapter(service, { 
  onNoMatch: 'passthrough',
  delayResponse: 1000
});

// 只在开发环境启用mock
if (process.env.NODE_ENV === 'development') {
  console.log('开发环境，启用mock拦截');
  
  // 禁用部分拦截，让请求能够被浏览器network捕获
  const disableMock = false; // 设置为true可以禁用所有mock拦截
  
  // 特定需要禁用的路径 - 让这些请求实际发送到后端
  const disablePathsRegex = [
    new RegExp(`.*${API_PATHS.AUTH.LOGIN}.*`), // 取消注释，禁用登录拦截
    new RegExp(`.*${API_PATHS.AUTH.REGISTER}.*`), // 禁用注册拦截，让请求发送到服务器
    new RegExp(`.*${API_PATHS.CAMPUS.LIST}.*`) // 禁用校区列表路径的mock拦截
  ];
  
  if (disableMock) {
    console.log('已禁用所有mock拦截，请求将实际发送');
    // 禁用所有拦截器
    globalMock.restore();
    serviceMock.restore();
  } else {
    console.log('配置特定路径的mock行为');
    
    // 对于需要禁用mock的路径，设置passThrough
    disablePathsRegex.forEach(regex => {
      console.log('禁用mock路径:', regex);
      // 对所有方法都禁用mock
      serviceMock.onGet(regex).passThrough();
      serviceMock.onPost(regex).passThrough();
      serviceMock.onPut(regex).passThrough();
      serviceMock.onDelete(regex).passThrough();
    });
    
    // 模拟数据
    const users = [];
    const campuses = [
      {
        id: 1,
        school_code: "SCH0001",
        campus_code: "CAM0001",
        campus_name: "西青校区",
        address: "天津市西青区溪华苑菜市场2楼",
        contact_phone: "19802267176",
        is_main: 1,
        star_level: 4,
        status: 1,
        home_url: "https://images.unsplash.com/photo-1554467711-b5587ef4d7fd",
        remark: null
      },
      {
        id: 2,
        school_code: "SCH0001",
        campus_code: "CAM0002",
        campus_name: "南开校区",
        address: "天津市南开区黄河道与密云路交口",
        contact_phone: "13502110574",
        is_main: 0,
        star_level: 3,
        status: 1,
        home_url: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f",
        remark: null
      },
      {
        id: 3,
        school_code: "SCH0001",
        campus_code: "CAM0003",
        campus_name: "河西校区",
        address: "天津市河西区友谊路与黑牛城道交口",
        contact_phone: "13820432560",
        is_main: 0,
        star_level: 5,
        status: 1,
        home_url: "https://images.unsplash.com/photo-1580582932707-520aed937b7b",
        remark: "新校区，环境优美"
      }
    ];
    
    // 测试请求是否正常工作 - 只拦截service实例
    serviceMock.onGet('/test').reply(200, { message: '服务Mock工作正常' });
    
    // 让全局axios不拦截请求，以便在Network面板看到
    globalMock.onAny().passThrough();
    
    // 服务实例拦截注册请求 - 注释掉这部分代码，不再拦截注册请求
    /* 
    serviceMock.onPost(new RegExp(`.*${API_PATHS.AUTH.REGISTER}`)).reply(function(config) {
      console.log('serviceMock拦截到注册请求');
      return handleRegister(config);
    });
    */
    
    // 处理注册请求的函数 - 保留函数定义，以便调试时可以参考格式
    function handleRegister(config) {
      console.log('拦截到注册请求:', config.url);
      console.log('请求数据:', config.data);
      
      try {
        const { username, password, role, schoolCode, phone, studentCode } = JSON.parse(config.data);
        
        // 检查用户名是否已存在
        const existingUser = users.find(user => user.username === username);
        if (existingUser) {
          console.log('用户名已存在:', username);
          return [400, { code: 400, msg: '注册失败，用户名已存在', data: null }];
        }
        
        // 创建新用户
        const newUser = {
          id: users.length + 1,
          username,
          password, // 实际应用中应加密存储
          role,
          schoolCode,
          phone: phone || '',
          studentCode: studentCode || '',
          createdAt: new Date().toISOString()
        };
        
        // 将用户添加到数组中
        users.push(newUser);
        
        console.log('注册成功，新用户:', newUser);
        console.log('当前用户列表:', users);
        
        // 返回成功响应，按照API文档格式
        return [200, { 
          code: 200, 
          msg: '注册成功', 
          data: { 
            userId: String(newUser.id),
            username: newUser.username,
            phone: newUser.phone || null,
            role: newUser.role,
            createTime: newUser.createdAt
          } 
        }];
      } catch (error) {
        console.error('处理注册请求时发生错误:', error);
        return [500, { code: 500, msg: '服务器错误', data: null }];
      }
    }
    
    // 服务实例拦截登录请求 - 注释掉这部分代码，不再拦截登录请求
    /* 
    serviceMock.onPost(new RegExp(`.*${API_PATHS.AUTH.LOGIN}`)).reply(function(config) {
      console.log('serviceMock拦截到登录请求');
      return handleLogin(config);
    });
    */
    
    // 验证登录请求已通过
    console.log('登录请求将不再被拦截，将直接发送到服务器');
    
    // 验证注册请求已通过
    console.log('注册请求将不再被拦截，将直接发送到服务器');
    
    // 服务实例拦截获取校区列表请求 - 只有当路径没有被禁用时才会生效
    serviceMock.onGet(new RegExp(`.*${API_PATHS.CAMPUS.LIST}`)).reply(function(config) {
      console.log('serviceMock拦截到获取校区列表请求');
      return handleGetCampusList(config);
    });
    
    // 处理获取校区列表请求的函数
    function handleGetCampusList(config) {
      console.log('拦截到获取校区列表请求:', config.url);
      
      try {
        // 检查认证头部
        const authHeader = config.headers['Authorization'];
        if (!authHeader) {
          console.log('未提供认证头部');
          return [401, { code: 401, msg: '未授权，请先登录' }];
        }
        
        // 模拟返回校区列表
        console.log('返回校区列表数据');
        return [200, {
          code: 200,
          msg: '获取校区列表成功',
          data: campuses
        }];
      } catch (error) {
        console.error('处理获取校区列表请求时发生错误:', error);
        return [500, { code: 500, msg: '服务器错误' }];
      }
    }
    
    console.log('模拟服务初始化完成');
  }
} else {
  console.log('非开发环境，禁用mock拦截');
  globalMock.restore();
  serviceMock.restore();
}

export { globalMock, serviceMock }; 